import React from "react";
import LazyLoad from "react-lazyload";
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <div className="footer padded-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="title">
                <p>contact us</p>
                <h2>get in touch</h2>
              </div>
            </div>
            <div className="col-md-12">
              <div className="footer-flex">
                <div className="contact_details">
                  <div>
                    <i className="bi bi-telephone-fill"></i>
                    <div>
                      <a href="tel: 9454376364">+91-9454376364</a> |{" "}
                      <a href="tel: 9415999947"> +91-9415999947</a>
                    </div>
                  </div>
                  <div>
                    <i className="bi bi-telephone-fill"></i>
                    <div>
                      <a href="tel: 0522-2972291">0522-2972291</a>{" "}
                    </div>
                  </div>
                  <div>
                    <i className="bi bi-envelope-fill"></i>
                    <div>
                      <a href="mailto:canossaschool@rocketmail.com">
                        canossaschool@rocketmail.com
                      </a>
                    </div>
                  </div>
                  <div>
                    <i className="bi bi-geo-alt-fill"></i>
                    <div>Kukrail Picnic Spot Road, Faridinagar, Lucknow</div>
                  </div>
                </div>
                <div>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3558.1989924498544!2d80.99298847606578!3d26.897179060756738!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39995804c4ff0789%3A0xf62f71b1099e6624!2sCanossa%20School%2C%20Lucknow!5e0!3m2!1sen!2sin!4v1755838852990!5m2!1sen!2sin"
                    width="600"
                    height="250"
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-blk padded-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4">
              <div className="ftr-logo">
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/logo.png"
                    alt="Cannosa school"
                  />
                </LazyLoad>
              </div>
            </div>

            <div className="col-md-4">
              <div className="social_media">
                <h4>follow us on</h4>
                <ul className="social-media">
                  <li>
                    <a
                      href="https://youtube.com/@canossaschoollucknow175?si=zpmuHpZw-nn4MRiA"
                      target="_blank"
                    >
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/youtube.png"
                        alt="Cannosa school"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="/" target="_blank">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/fb.png"
                        alt="Cannosa school"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="/" target="_blank">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/insta.png"
                        alt="Cannosa school"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="/" target="_blank">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/linkdin.png"
                        alt="Cannosa school"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-4">
              <div className="mobile-app">
                <div>
                  <h3>MOBILE APP </h3>
                  <p>
                    Be the best school and save time, money, environment, and
                    workforce by downloading the school mobile app.
                  </p>
                  <div className="mobile-link">
                    <a href="https://play.google.com/store/apps/details?id=com.campuscare.entab.ui">
                      {" "}
                      <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/app-store.png" />
                    </a>
                    <a href="https://apps.apple.com/in/app/campuscare/id1034721587">
                      {" "}
                      <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/play-store.png" />
                    </a>
                  </div>
                  <p className="code">canossa.campuscare.info</p>
                </div>
                <div>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/Mobile-slides.png"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright">
        ©️Copyright 2017 - 2025 Cannosa School, Lucknow. All Rights Reserved |
        Accelerating By Entab Infotech : CampusCare®️
      </div>
    </>
  );
};

export default Footer;
